var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup190(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.005,
    height: 32.739,
    viewBox: "0 0 34.005 32.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.005,
    height: 32.739,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.366,32.739A45.717,45.717,0,0,0,24.42,27.57l7.293-3.286a53.281,53.281,0,0,1,2.292,6.081Z",
    fill: "#001233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.844,22.8A32.652,32.652,0,0,0,18.6,18.537l5.943-5.355a40.852,40.852,0,0,1,4.034,5.3Z",
    fill: "#001233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.712,14.883a35.07,35.07,0,0,0-4.477-3.007l3.95-6.957a43.112,43.112,0,0,1,5.5,3.7Z",
    fill: "#001233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29,9.5A52.662,52.662,0,0,0,0,7.693L2.2,0A61.124,61.124,0,0,1,8.292,2.084Z",
    fill: "#001233"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup190);
export default __webpack_public_path__ + "static/media/Group190.b1d85cfe93c757d3c957ebfdab62abc5.svg";
export { ForwardRef as ReactComponent };